import styled from "styled-components";

export const MainHeaderContainer = styled.div`
  position: fixed;
  width: 100%;
  z-index: 1;
`;
